import { render } from "./CustomerMealReservationDetail.vue?vue&type=template&id=15eb9c14&scoped=true"
import script from "./CustomerMealReservationDetail.vue?vue&type=script&lang=js"
export * from "./CustomerMealReservationDetail.vue?vue&type=script&lang=js"

import "./CustomerMealReservationDetail.vue?vue&type=style&index=0&id=15eb9c14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15eb9c14"]])

export default __exports__